import styled from 'styled-components'
import appStoreButtonImage from '../../../assets/landing/appStoreButton.svg'
import googlePlayButtonImage from '../../../assets/landing/googlePlayButton.svg'

const SectionWrapper = styled.section`
  width: 100%;
  min-height: 620px;
  background: linear-gradient(360deg, #f48d62 0%, #f25564 35%, #f74676 70%, #f86286 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  gap: 20px;
  box-sizing: border-box;
`

const Title = styled.h2`
  color: white;
  font-size: 42px;
  font-weight: 500;
  font-style: italic;
  text-align: center;
  margin: 0;

  strong {
    font-weight: 700;
    font-style: normal;
  }

  @media (max-width: 768px) {
    font-size: 28px;
  }
`

const Subtitle = styled.p`
  color: white;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  margin: 0;
  max-width: 700px;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`

const DownloadButton = styled.a`
  background: white;
  border: none;
  border-radius: 100px;
  padding: 13px 47px;
  cursor: pointer;
  margin-top: 20px;
  transition: transform 0.2s, box-shadow 0.2s;
  text-decoration: none;
  color: black;
  font-size: 18px;
  font-weight: 500;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  }
`

const AppStoreLinks = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 10px;

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: center;
  }
`

const StoreButton = styled.a`
  display: block;
  transition: transform 0.2s;

  &:hover {
    transform: translateY(-2px);
  }

  img {
    display: block;
    height: 40px;
    width: auto;
  }
`

const CTASection = () => {
  return (
    <SectionWrapper>
      <Title>
        Start Designing Your Dream Home with <strong>DecorMatters.</strong>
      </Title>
      <Subtitle>
        Design real rooms, explore millions of ideas, and create with AI - all in one home design
        app.
      </Subtitle>
      <DownloadButton
        href="https://decormatters.app.link/WTHVetOFCMb"
        target="_blank"
        rel="noopener noreferrer"
      >
        Download Our App
      </DownloadButton>
      <AppStoreLinks>
        <StoreButton
          href="https://apps.apple.com/us/app/decor-matters-design-shop/id1168709467"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={appStoreButtonImage} alt="Download on the App Store" />
        </StoreButton>
        <StoreButton
          href="https://play.google.com/store/apps/details?id=com.decormatters.prod"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={googlePlayButtonImage} alt="Get it on Google Play" />
        </StoreButton>
      </AppStoreLinks>
    </SectionWrapper>
  )
}

export default CTASection
